module.exports = __webpack_public_path__ + "static/media/5.9634776e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/5.png
// module id = 1102
// module chunks = 0